import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=4eb092b1&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&id=4eb092b1&scoped=true&lang=css&"
import style1 from "bootstrap-vue/dist/bootstrap-vue.css?vue&type=style&index=1&id=4eb092b1&scoped=true&lang=css&"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=4eb092b1&scoped=true&lang=css&"
import style3 from "./CompanySettings.vue?vue&type=style&index=3&id=4eb092b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb092b1",
  null
  
)

export default component.exports